import type { Task } from "../lib/api";

export function Mits({
  mits,
  onToggle,
}: {
  mits: Task[];
  onToggle: (t: Task) => void;
}) {
  return (
    <div className="mits">
      {[0, 1, 2].map((i) => {
        const t = mits[i];
        return (
          <div key={i} className={`mit${t ? " filled" : ""}`}>
            <div className="n">0{i + 1}</div>
            {t ? (
              <>
                <div className="mtt">{t.title}</div>
                <button
                  className={`chk mchk${t.status === "done" ? " on" : ""}`}
                  onClick={() => onToggle(t)}
                  aria-label="Toggle done"
                />
              </>
            ) : (
              <div className="empty">Star a task to set a Top-3</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
